export default {"src":"/_next/static/media/carOutline50_40.0872289a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};